import React from 'react';
import './index.css';
// import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';

function App() {
  return (
    <div className='App'>
      <Home />
      </div>
  );
}

export default App;
